import { render, staticRenderFns } from "./LegalApplicantForm.vue?vue&type=template&id=4606af0a&"
import script from "./LegalApplicantForm.vue?vue&type=script&lang=js&"
export * from "./LegalApplicantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports